export default __webpack_public_path__ + "static/media/login.3fc212e7.png";